import React from 'react';
import { Link } from 'react-router-dom';
import { fromNow } from '../../util/util';
import styled from 'styled-components';
import SortableTable from '../table/SortableTable';
import { GetCampaignsResult } from '../../model/GetCampaignsResult';
import { CampaignStatus } from '../../model/Campaign';


interface IProps{
    campaignResult:GetCampaignsResult
    onEditCampaign:(campaignId:string)=>void
}

const Style = styled.div`
.email-marketing-test{
    color: #fff;
    background-color: orange;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 0%.8rem;
    margin-left: 5px;
}

`;

const CreatedColumn = 'Created';
const StatusColumn = 'Status';
const SubjectColumn = 'Subject';
const getHeaders = () =>  {
    return [ CreatedColumn,  StatusColumn, SubjectColumn  ];    
}


const CampaignsTable: React.FC<IProps>= (props:IProps) => {
    const campaignResult = props.campaignResult;

    const data:any[][] = [];
      if(campaignResult){
          for(let x of campaignResult.campaigns){
              let arr:any[] = []

              arr = [
                  x.created,
                  x.status,
                  x.id,
                  x
              ]

              data.push(arr)
          }
      }

    const cellFormatter = (columnName:string, cell:any, campaign:any):React.ReactNode => {
        if(columnName===CreatedColumn){
            return <span>{fromNow(campaign.created)} { campaign.isTest ? <span className='email-marketing-test'>Test</span>:'' }</span>
        }
        else if(columnName===SubjectColumn){
            const newTo = {
                pathname: `/CampaignStats/${encodeURIComponent(campaign.id)}`,
              };
            // return <span>{cell} <a href={campaignUrl}>[View Campaign]</a></span>
            return <div className='space-between'>
            <span>{campaign.subject}
            { !campaign.isTest && <Link to={newTo}> [View Campaign]</Link>}
            </span>

            { campaign.status===CampaignStatus.Draft && <button className='button-sm link button-as-link' onClick={(e)=>props.onEditCampaign(campaign.id)}>[Edit]</button>}
            </div>
        }


        return null;
    }

    return <Style>
        <SortableTable headers={getHeaders()} data={data} cellFormatter={cellFormatter} sortDirection='desc' />
    </Style>
}

export default CampaignsTable